//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  Box,
} from '@mui/material';
import { Add } from '@mui/icons-material';

// === COMPONENTS ===
import { Spacer             } from 'components/Spacer.jsx';
import { InfoView           } from './components/InfoView/InfoView.jsx';
import { ExpressionView     } from './components/ExpressionView/ExpressionView.jsx';
import { ExpressionProvider } from './components/ExpressionView/components/Context/ExpressionContext.jsx';

// === API ===
import { on, removeListener, requestFile, sendMessage } from 'api/prokey/prokey.websocket';

// === UTILS ===

//#endregion

//-----------------------------------------------------------------
export function RuleView() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const navigate = useNavigate();

  //#endregion

  //#region [STYLES]

  const theme = useTheme();
  const _styles = {
    container: {
      height: 'calc( 100% - 1rem )',
      width: '100%',
      boxShadow: 0,
      paddingTop: '1rem',
      paddingLeft: '1rem',
      paddingRight: '1rem',
      overflow: 'hidden',
    },
    border_1: {
      display: 'flex',
      // border: 'solid ' + theme.palette.primary[theme.palette.mode],
      borderRadius: '1rem',
      padding: '1rem',
      width: 'max-content',
    },
    border_3: {
      // border: 'solid ' + theme.palette.primary[theme.palette.mode],
      borderRadius: '1rem',
      padding: '1rem',
      width: 'max-content',
      height: '20%',
    },
    border_2: {
      display: 'grid',
      gridTemplateColumns : '1fr',
      // gridTemplateRows    : 'repeat(2, 1fr)',
      gridAutoRows: 'auto 1fr',
      // border: 'solid ' + theme.palette.primary[theme.palette.mode],
      borderRadius: '1rem',
      padding: '1rem',
      width: 'max-content',
      height: '100%',
      overflow: 'hidden',
      backgroundColor: theme.palette.background.primary[theme.palette.mode]
    },
    button_add: {
      backgroundColor: theme.palette.primary[theme.palette.mode],
      color: 'white',
    },
  }

  const CONTAINER = {
    sx: _styles.container,
  };
  const BORDER_2 = {
    style: _styles.border_2,
  };
    
  //#endregion

  //#region [EFFECT]

  //#endregion

  //#region [MODIFY]

  //#endregion

  //#region [EVENTS]

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Box {...CONTAINER}>
        <div { ...BORDER_2 } >
          <ExpressionProvider>
            <InfoView />
            <ExpressionView />
          </ExpressionProvider>
        </div>
      </Box>
    );
  }

  //#endregion

  return display();
}
